import React from 'react'
import {create} from 'dva-core'
import models from '../src/Models'
import {createLogger} from 'redux-logger'
import {persistReducer} from 'redux-persist'
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2'

const createNoopStorage = () => {
  return {
    getItem(_key) {
      return Promise.resolve(null)
    },
    setItem(_key, value) {
      return Promise.resolve(value)
    },
    removeItem(_key) {
      return Promise.resolve()
    },
  }
}

const getStorage = () => {
  if (typeof window === 'undefined') {
    return createNoopStorage()
  }
  return require('redux-persist/lib/storage').default
}

export default function dva(otherModels = []) {
    const options = {
        initialState: {},
        models: [...models, ...otherModels],
        onReducer(reducer) {
            const persistConfig = {
                key: 'root',
                storage: getStorage(),
                stateReconciler: autoMergeLevel2,
                blacklist: [''], // navigation will not be persisted
                whitelist: [
                    'magento',
                    'coreCommonInfo',
                    'browseCatalog',
                    'contentful',
                    'checkout',
                    'WomCheckoutV2'
                ], // only navigation will be persisted
            }
            return persistReducer(persistConfig, reducer)
        },

        onError(e) {
            console.log(e)
            // Product-Recommendations('onError index:', e)
        },
    }
    if (process.env.NODE_ENV !== 'production') {
        // onAction: [routerMiddleware ],
        // 使用日志打印方法， collapsed让action折叠，看着舒服。
        // options.onAction = [createLogger({collapsed: true, duration: true})]
    }
    const app = create(options)
    options.models.forEach(model => app.model(model))
    app.start()
    app.getStore = () => app._store
    return app
}
